import { createFeatureSelector, createSelector } from '@ngrx/store';
import { classroomCourseAdapter } from './classroom-course.entity';
import { ClassroomCourseState, classroomFeatureKey } from './classroom-course.state';

export const { selectAll, selectEntities, selectIds, selectTotal } = classroomCourseAdapter.getSelectors();

export const getClassroomCourseState = createFeatureSelector<ClassroomCourseState>(classroomFeatureKey);

export const getAllClassroomCourse = createSelector(getClassroomCourseState, selectAll);

export const getClassroomCourseById = (id: string) =>
  createSelector(getClassroomCourseState, (state) => state.entities[id]);
export const getClassroomCourseBySlug = (slug: string) =>
  createSelector(getAllClassroomCourse, (state) => {
    return state.find((item) => item.slug === slug);
  });

export const getSelectedClassroomCourse = createSelector(
  getClassroomCourseState,
  (state) => state.entities[state.selectedCourseId]
);
export const getClassroomCourseId = createSelector(getClassroomCourseState, (state) => state.selectedCourseId);
export const getAvailableSchedule = createSelector(getClassroomCourseState, (state) => state.schedules.filter(schedule => schedule.status && !schedule.isSignUpDateExpired));
export const getInstructorCourse = createSelector(getClassroomCourseState, (state) => state.instructorCourses);

export const getError = createSelector(getClassroomCourseState, (state) => state.error);

export const getFilter = createSelector(getClassroomCourseState, (state) => state.filter);

export const getTotalCount = createSelector(getClassroomCourseState, (state) => state.totalCount);
export const getParticipantIdentity = createSelector(getClassroomCourseState, (state) => state.participantIdentity);
